import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import { ParentService } from './../pages/A2-utils/ParentClass/ParentService';
import { constant } from '../app.constants';
import * as io from 'socket.io-client';

@Injectable()
export class TrackerService extends ParentService {

  private url = 'https://socket-tracker.herokuapp.com/';
  private socket;

  constructor( private _http: Http ) {
    super();
  }

  getLocations() {
    let observable = new Observable(observer => {
      this.socket = io(this.url);
      this.socket.on('live-map', (data) => {
        observer.next(data);
      });

      return () => {
        this.socket.disconnect();
      }
    })
    return observable;
  }

  getLocationTracker(driverId: number, dateInitial, dateEnd) {
    return this._http.get(`${constant.URL_LOCATION_TRACKER}\\${driverId}?date=${dateInitial}&dateFinal=${dateEnd}`, this.getHeader()).map(
      res => res.json()
    );
  }

  putUnitCode(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_VEHICLE_UPDATE_UNIT, bodyString, this.headerPost());
  }


}



// WEBPACK FOOTER //
// ./src/app/services/tracker.service.ts